<template>
    <div id="map"></div>
</template>

<script>
    import L from 'leaflet';
    import * as _ from "lodash";

    export default {
        data() {
            return {
                map: Object,
                icon: {},
                locateDeviceMapicon: {
                    iconUrl: '../../../images/marker-icon.png',
                    iconSize: [25, 41],
                    iconAnchor: [12, 41],
                    popupAnchor: [1, -34],
                    tooltipAnchor: [16, -28],
                    shadowSize: [41, 41]
                },
                arrayLayers: [],
            }
        },
        props: {
            coordinateMap: Object,
            arrayMarkers: Array,
        },
        watch: {
            coordinateMap: function () {
                let container = L.DomUtil.get('map');
                if (container != null) {
                    container._leaflet_id = null;
                }

                //Déclaration de la map
                this.map = L.map('map').setView(this.coordinateMap, 13);

                // Remplacement d'icône par défaut pour les markers
                this.icon = L.icon(this.locateDeviceMapicon);

                // On applique le fond de map PSM
                L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                    attribution: 'Map data © <a href="http://openstreetmap.org">OpenStreetMap</a> contributors',
                }).addTo(this.map);
            },

            arrayMarkers: function () {
                //Supprime les anciens marqueur
                _.forEach(this.arrayLayers, layer => {
                    layer.remove();
                });
                this.arrayLayers = [];

                //On ajoute les nouveaux marqueurs
                _.forEach(this.arrayMarkers, value => {
                    let latLng = new L.latLng([value.latitude, value.longitude]);
                    let layer = L.marker(latLng, {icon: this.icon}).addTo(this.map);
                    this.arrayLayers.push(layer);
                });
            }
        },
    }
</script>

<style>
    @import "~leaflet/dist/leaflet.css";

    #map {
        z-index: 1;
    }
</style>


// WEBPACK FOOTER //
// resources/js/components/layout/OpenStreetMap.vue